/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100ConflictException } from './Ptw100ConflictException';
import {
    Ptw100ConflictExceptionFromJSON,
    Ptw100ConflictExceptionFromJSONTyped,
    Ptw100ConflictExceptionToJSON,
} from './Ptw100ConflictException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100ConflictException
 */
export interface ErrorResponseOfPtw100ConflictException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100ConflictException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100ConflictException}
     * @memberof ErrorResponseOfPtw100ConflictException
     */
    exception: Ptw100ConflictException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100ConflictException
     */
    $type?: ErrorResponseOfPtw100ConflictExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100ConflictExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100ConflictExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100ConflictException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100ConflictExceptionTypeEnum = typeof ErrorResponseOfPtw100ConflictExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100ConflictExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100ConflictException interface.
 */
export function instanceOfErrorResponseOfPtw100ConflictException(value?: unknown): value is ErrorResponseOfPtw100ConflictException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100ConflictExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100ConflictExceptionFromJSON(json: any): ErrorResponseOfPtw100ConflictException {
    return ErrorResponseOfPtw100ConflictExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100ConflictExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100ConflictException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100ConflictExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100ConflictExceptionToJSON(value?: Omit<ErrorResponseOfPtw100ConflictException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100ConflictExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

